var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pods"}},[_c('div',{staticClass:"tile is-ancestor",staticStyle:{"flex-wrap":"wrap"}},_vm._l((_vm.pods),function(pod){return _c(pod.component,_vm._b({key:pod.id,tag:"component"},'component',pod.props,false))}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }